import { Badge, Box } from '@palmetto/palmetto-components';
import { Helmet } from 'react-helmet';
import { Link, NavLink, Route, Routes, useParams } from 'react-router-dom';

import { FundType, FundTypesLabels } from 'types';

import { useGetFundQuery } from '../../services/funds';
import { MainContainer } from '../MainContainer';
import PageHeader from '../PageHeader';
import { SkeletonBox } from '../SkeletonBox';

import { FundHistory } from './FundHistory';
import { FundOverview } from './FundOverview';

export function Fund() {
  const { key } = useParams<{ key: any }>();
  const { data: fund = {}, isFetching } = useGetFundQuery(key);

  return (
    <>
      <Helmet>
        <title>Fund</title>
      </Helmet>
      <MainContainer>
        <PageHeader
          eyebrow={<Link to="/admin/funds">Funds</Link>}
          title={fund?.description ?? <SkeletonBox height="50px" width="400px" />}
          description={
            <Box direction="row">
              <Badge
                variant="info"
                message={
                  !isFetching ? (
                    FundTypesLabels[fund.fundType as FundType]
                  ) : (
                    <SkeletonBox height="14px" width="90px" />
                  )
                }
                size={{ base: 'md', desktop: 'lg' }}
              />
            </Box>
          }
        />
        <Box direction="row" borderWidth="0 0 xs 0" borderColor="separator">
          <NavLink to={`/admin/funds/${key}`} style={{ textDecoration: 'none', fontWeight: '500' }} end>
            {({ isActive }) => (
              <Box
                as="span"
                padding="md"
                className={isActive ? 'tab-active' : ''}
                hover={{ color: 'primary' }}
                style={{ transitionDuration: '0s' }}
              >
                Overview
              </Box>
            )}
          </NavLink>
          <NavLink to={`/admin/funds/${key}/history`} style={{ textDecoration: 'none', fontWeight: '500' }}>
            {({ isActive }) => (
              <Box
                as="span"
                padding="md"
                className={isActive ? 'tab-active' : ''}
                hover={{ color: 'primary' }}
                style={{ transitionDuration: '0s' }}
              >
                History
              </Box>
            )}
          </NavLink>
        </Box>
        <Routes>
          <Route path="/" element={<FundOverview />} />
          <Route path="/history" element={<FundHistory />} />
        </Routes>
      </MainContainer>
    </>
  );
}
